module.exports = __webpack_public_path__ + "static/img/iconmonstr-media-control-50.5a1093e9.svg";